import { render, staticRenderFns } from "./EditLesson.vue?vue&type=template&id=1a933af2"
import script from "./EditLesson.vue?vue&type=script&lang=js"
export * from "./EditLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports